<ng-container *ngIf="column && data">
  <ng-container *ngFor="let prop of properties; index as i" [ngSwitch]="true">
    <ng-container *ngSwitchCase="prop.key === keys.InspectionSummaryLocationIdentifier">
      <div [style]="column.isItemsHorizontal ? horizontalStyle : divStyle">
        <ng-container *ngIf="!isSaveHtml">
          <a [style]="anchorLinkStyle" [routerLink]="" (click)="scrollToHashLink(data.id)">{{ data.identifiers[prop.index] }}</a>
        </ng-container>
        <ng-container *ngIf="isSaveHtml">
          <a href="#{{ data.id }}">{{ data.identifiers[prop.index] }}</a>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.InspectionSummaryLocationLowermostIdentifier">
      <div [style]="column.isItemsHorizontal ? horizontalStyle : divStyle">
        <ng-container *ngIf="!isSaveHtml">
          <a [style]="anchorLinkStyle" [routerLink]="" (click)="scrollToHashLink(data.id)">{{ data.identifiers[data.identifiers.length - 1] }}</a>
        </ng-container>
        <ng-container *ngIf="isSaveHtml">
          <a href="#{{ data.id }}" (click)="scrollToHashLink(data.id)">{{ data.identifiers[data.identifiers.length - 1] }}</a>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.InspectionPicturesLocationIdentifier">
      <div *ngIf="data.identifiers.length > prop.index" id="{{ data.id }}" [style]="column.isItemsHorizontal ? horizontalStyle : divStyle">
        {{ data.identifiers[prop.index] }}
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.InspectionPicturesLocationLowermostIdentifier">
      <div id="{{ data.id }}" [style]="column.isItemsHorizontal ? horizontalStyle : divStyle">
        {{ data.identifiers[data.identifiers.length - 1] }}
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.InspectionSummaryLocationName || prop.key === keys.InspectionPicturesLocationName">
      <ng-container *ngIf="data.names.length > prop.index">
        <div *ngIf="i > 0 && data.names[prop.index] !== null && data.names[prop.index] !== ''" [style]="divInlineStyle">,</div>
        <div [style]="column.isItemsHorizontal ? horizontalStyle : divInlineStyle">{{ data.names[prop.index] }}</div>
      </ng-container>
    </ng-container>
    <ng-container
      *ngSwitchCase="prop.key === keys.InspectionSummaryLocationLowermostName || prop.key === keys.InspectionPicturesLocationLowermostName"
    >
      <div [style]="column.isItemsHorizontal ? horizontalStyle : divStyle">{{ data.names[data.names.length - 1] }}</div>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.InspectionSummaryInspectionFor || prop.key === keys.InspectionPicturesInspectionFor">
      <div style="overflow: hidden; word-break: break-all">
        <ol style="text-align: left; list-style-type: lower-alpha; padding-left: 25px">
          <li *ngFor="let str of data.inspectionFor" style="line-height: 1.5em; white-space: pre-wrap; word-break: normal">
            {{ str }}
          </li>
        </ol>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.InspectionSummaryClass">
      <div [style]="(column.isItemsHorizontal ? horizontalStyle : divStyle) + relativeStyle" [style.background-color]="getMarkItem(data.mark)?.color">
        <div class="inspection-summary-class" *ngIf="isTargetMark(data.mark)" [style]="classMarkStyle">{{ data.mark }}</div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.InspectionPicturesClass">
      <div
        *ngIf="!isTargetMark(data.mark) && !hasDummyImage(data.images)"
        [style]="(column.isItemsHorizontal ? horizontalStyle : divStyle) + relativeStyle"
      >
        <div class="mark inspection-summary-class" [style]="classMarkStyle">{{ data.mark }}</div>
      </div>
      <div
        *ngIf="isTargetMark(data.mark) && !hasDummyImage(data.images)"
        [style]="(column.isItemsHorizontal ? horizontalStyle : divStyle) + relativeStyle"
        [style.background-color]="getMarkItem(data.mark)?.color"
      >
        <div class="mark inspection-summary-class" [style]="classMarkStyle">{{ data.mark }}</div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.InspectionSummaryMark">
      <div *ngIf="prop.index === data.mark" [style]="(column.isItemsHorizontal ? horizontalStyle : divStyle) + flexStyle + heatMaxStyle">
        &#10004;
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.InspectionPicturesMark">
      <div *ngIf="!isTargetMark(data.mark) && !hasDummyImage(data.images)" [style]="column.isItemsHorizontal ? horizontalStyle : divStyle">
        {{ data.mark }}
      </div>
      <div *ngIf="isTargetMark(data.mark) && !hasDummyImage(data.images)" [style]="column.isItemsHorizontal ? horizontalStyle : divStyle">
        {{ getMarkItem(data.mark)?.label }}
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.InspectionSummaryTitle || prop.key === keys.InspectionPicturesTitle">
      <div [style]="column.isItemsHorizontal ? horizontalStyle : divStyle">{{ data.title }}</div>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.InspectionSummaryComment || prop.key === keys.InspectionPicturesComment">
      <div [style]="column.isItemsHorizontal ? horizontalStyle : divStyle">{{ data.comment }}</div>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.InspectionPicturesImage">
      <ng-container *ngFor="let image of data.images">
        <app-report-column-image
          [image]="image"
          [isColumnStyle]="data.images.length > column.textsInfo.length"
          [sizeUnit]="sizeUnit"
          [width]="image.usedImageMode === 1 ? getImageWidth(image.modifiedWidth) : getImageWidth(image.width)"
          [height]="image.usedImageMode === 1 ? getImageHeight(image.modifiedHeight) : getImageHeight(image.height)"
          [maxWidth]="getImageMaxWidth()"
          [maxHeight]="isDoubleHeight(image) ? getImageMaxHeight() * 2 : getImageMaxHeight()"
          [minWidth]="tableWidth"
          [isItemsHorizontal]="column.isItemsHorizontal"
          [columnCount]="column.textsInfo.length"
          [imageCount]="data.images.length"
          [horizontalAlign]="column.horizontalAlign"
          [verticalAlign]="column.verticalAlign"
          [pictureKey]="pictureKey"
          [widthRatio]="widthRatio"
        >
        </app-report-column-image>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.InspectionLocationIdentifierComment">
      <div [style]="column.isItemsHorizontal ? horizontalStyle : divStyle">{{ getInspLocationComment() }}</div>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.MeasurementResultWithObjectDistance">
      <div
        [style.max-height]="trHeight + sizeUnit"
        [style]="column.isItemsHorizontal ? horizontalStyle + 'white-space: nowrap;' : divStyle + 'white-space: nowrap;'"
      >
        <app-report-measurement [image]="data"></app-report-measurement>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.MeasurementResult">
      <app-report-measurement [image]="data.previewImage"></app-report-measurement>
    </ng-container>
    <ng-container *ngSwitchCase="prop.key === keys.Border">
      <div style="border: 1px solid #000000"></div>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div [style]="column.isItemsHorizontal ? horizontalStyle : divStyle">{{ prop.text }}</div>
    </ng-container>
    <div *ngIf="prop.key !== keys.InspectionPicturesImage && column.isItemsHorizontal && i < properties.length - 1" [style]="divSpaceStyle">
      {{ divSpace }}
    </div>
    <ng-container
      *ngIf="
        column.textsInfo.length > 1 &&
        !column.isItemsHorizontal &&
        prop.key !== keys.InspectionSummaryLocationName &&
        prop.key !== keys.InspectionPicturesLocationName &&
        prop.key !== keys.InspectionPicturesImage
      "
    >
      <br />
    </ng-container>
  </ng-container>
</ng-container>
